const analyticsEvents = {
  ERROR: 'towns_to_error',
  SUCCESS: 'towns_to_success',
};

export const townsToConfig = {
  analyticsEvents,
};
